module.exports = __webpack_public_path__ + "img/fbxq.383f618.png";